import type { EmailDeliveryMeasures as GQLItem } from '../../../generated/internal.graphql';
import { take } from '../../../util/takePayload';

/**
 * What one summary group measures: how many sends it covers, how many landed, how many failed, and
 * the failure rate over those.
 *
 * `failureRate` is already `failed / sent` from the database, and `0.0` when nothing was sent — so
 * it is carried through rather than recomputed here, where a zero denominator would have to be
 * handled a second time and could disagree with the backend's answer.
 */
export type EmailDeliveryMeasures = {
  sent: number;
  delivered: number;
  failed: number;
  failureRate: number;
};

export const fromGql = (item: GQLItem): EmailDeliveryMeasures =>
  take<EmailDeliveryMeasures>(item, 'sent', 'delivered', 'failed', 'failureRate');
